import React, { useState } from "react";

export default function PanInput({
  id,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}) {
  const [realValue, setRealValue] = useState("");

  const handleChange = (e) => {
    let entered = e.target.value.toUpperCase();
    let raw = realValue;

    // Handle typing and backspace
    if (entered.length > raw.length) {
      raw += entered.slice(raw.length);
    } else {
      raw = raw.slice(0, entered.length);
    }

    // Allow only A-Z and 0-9
    raw = raw.replace(/[^A-Z0-9]/g, "").slice(0, 10);

    setRealValue(raw);

    // Mask middle 4 digits
    // ABCDE1234F => ABCDE****F
    let masked = raw
      .split("")
      .map((char, i) => (i >= 5 && i <= 8 ? "*" : char))
      .join("");

    // Send both values
    onChange && onChange(masked, raw);

    // Show masked value in input
    e.target.value = masked;
  };

  return (
    <div className="relative">
      <i className="fa fa-id-card absolute left-3 top-3 text-[#FF702B] text-sm"></i>

      <input
        type="text"
        id={id}
        disabled={disabled}
        placeholder="ABCDE1234F"
        className={`w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400
          focus:outline-none focus:ring-0 focus:border-[#FF702B]
          ${disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"}
          ${error ? "border-red-500" : ""}`}
        value={value || ""}
        onChange={handleChange}
        onBlur={onBlur}
        maxLength={10}
      />

      {error && <span className="error">{error}</span>}
    </div>
  );
}